import { $http } from "@/utils/https";
import {
    CHANGE_LOADING,
    CHANGE_PROGRESS_LOADING,
    INCREMENT_PROGRESS_LESSON,
    SET_CURRENT_ITEM,
    SET_DATA_PROGRESS_LESSON,
    SET_LESSON_RATE,
    SET_MODULE,
} from "./types/mutation-types";

import {
    GET_LIST,
    CREATE_LESSON_RATE,
    FETCH_LESSON,
    SET_LESSON_FAVOURITE,
    SET_LESSON_UNFAVOURITE,
    UPDATE_LESSON_RATE,
    UPDATE_LESSON_RATE_COMMENT,
    UPDATE_PROGRESS_LESSON,
} from "./types/action-types";

const state = {
    lesson: null,
    module: null,
    isLoading: false,
    isProgressLoading: false,
    selectedVideoId: null,
};

const modifySummary = (state, plus) => {
    if (state.lesson.userRating.data.rating) {
        const key = state.lesson.userRating.data.rating - 1;
        if (state.lesson.ratingSummary && state.lesson.ratingSummary.data[key]) {
            if (plus) {
                state.lesson.ratingSummary.data[key].count += 1;
            } else {
                state.lesson.ratingSummary.data[key].count -= 1;
            }
        }
    }
};

const getters = {
    lesson: (state) => state.lesson,
    isLoading: (state) => state.isLoading,
    isProgressLoading: (state) => state.isProgressLoading,
    module: (state) => state.module,
    selectedVideoId: (state) => state.selectedVideoId,
    hasCreatedRate: (state) =>
        state.lesson && !Array.isArray(state.lesson.userRating.data),
};

const actions = {
    [FETCH_LESSON]: async ({ commit }, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            const response = await $http.get(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/lessons/${payload.lessonSlug}?include=video,userLesson,ratingSummary,userRating,rating,module.userModule,files,image,seo,course,course.category,module,module.materials,module.materials.speakers,module.materials.userLesson,module.materials.userHomeWork,speakers,video.chapters,video.image,module.materials.speakers&use_as_id=slug`
            );
            commit(SET_CURRENT_ITEM, response.data.data);
            commit(SET_MODULE, response.data.data.module.data);

            let lesson = response.data.data;

            if (lesson.video.data.length) {
                commit("SET_VIDEO_ID", lesson.video.data[0].id);
            }

            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
    [UPDATE_PROGRESS_LESSON]: async ({ commit }, payload) => {
        try {
            commit(CHANGE_PROGRESS_LOADING, true);
            let response = "";
            if (payload.type === "start") {
                response = await $http.post(
                    `${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/lessons/${payload.slug}/start?include=&use_as_id=slug`
                );
                commit(SET_DATA_PROGRESS_LESSON, response.data.data);
            } else {
                payload._method = "patch";
                response = await $http.post(
                    `${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/lessons/${payload.slug}/complete?include=&use_as_id=slug`,
                    payload
                );
                commit(SET_DATA_PROGRESS_LESSON, response.data.data);
                commit(INCREMENT_PROGRESS_LESSON, response.data.data);
            }
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_PROGRESS_LOADING, false);
        }
    },
    [CREATE_LESSON_RATE]: async ({ commit }, { item, moduleSlug, slug, rating }) => {
        try {
            commit(SET_LESSON_RATE, {
                data: { rating, comment: "" },
                changeSummary: true,
            });
            const {
                data,
            } = await $http.post(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${item}/modules/${moduleSlug}/lessons/${slug}/ratings?include=&use_as_id=slug`,
                { rating }
            );
            commit(SET_LESSON_RATE, data);
        } catch (e) {
            throw e;
        }
    },
    [UPDATE_LESSON_RATE]: async (
        { commit },
        { item, moduleSlug, slug, rateId, rating }
    ) => {
        try {
            commit(SET_LESSON_RATE, {
                data: { rating, comment: "" },
                changeSummary: true,
            });
            const {
                data,
            } = await $http.post(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${item}/modules/${moduleSlug}/lessons/${slug}/ratings/${rateId}/rating?include=&use_as_id=slug`,
                { rating, _method: "patch" }
            );
            commit(SET_LESSON_RATE, data);
        } catch (e) {
            throw e;
        }
    },
    [UPDATE_LESSON_RATE_COMMENT]: async (
        { commit },
        { item, moduleSlug, slug, rateId, comment }
    ) => {
        try {
            const {
                data,
            } = await $http.post(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${item}/modules/${moduleSlug}/lessons/${slug}/ratings/${rateId}/comment?include=&use_as_id=slug`,
                { comment, _method: "patch" }
            );
            commit(SET_LESSON_RATE, data);
        } catch (e) {
            throw e;
        }
    },
    [SET_LESSON_FAVOURITE]: async ({ commit }, { slug }) => {
        try {
            await $http.post(`${process.env.VUE_APP_ROOT_COURSE}my/courses/pin`, {
                slug,
            });
        } catch (e) {
            throw e;
        }
    },
    [SET_LESSON_UNFAVOURITE]: async ({ commit }, { slug }) => {
        try {
            await $http.post(`${process.env.VUE_APP_ROOT_COURSE}my/courses/unpin`, {
                slug,
            });
        } catch (e) {
            throw e;
        }
    },
};

const mutations = {
    SET_VIDEO_ID(state, id) {
        state.selectedVideoId = id;
    },

    [SET_CURRENT_ITEM](state, data) {
        state.lesson = data;
    },
    [SET_MODULE](state, data) {
        state.module = data;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoading = status;
    },
    [CHANGE_PROGRESS_LOADING](state, status) {
        state.isProgressLoading = status;
    },
    [SET_DATA_PROGRESS_LESSON](state, data) {
        state.lesson.userLesson.data = data;
    },
    [INCREMENT_PROGRESS_LESSON](state, data) {
        state.module.userModule.data.completedMaterials++;
    },
    [SET_LESSON_RATE](state, { data, changeSummary }) {
        if (changeSummary) {
            modifySummary(state, false);
        }
        state.lesson.userRating.data = data.rating === 0 ? [] : data;
        if (changeSummary) {
            modifySummary(state, true);
        }
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
